import { render, staticRenderFns } from "./AnalysisDetail.vue?vue&type=template&id=6ef8a892&scoped=true&"
import script from "./AnalysisDetail.vue?vue&type=script&lang=js&"
export * from "./AnalysisDetail.vue?vue&type=script&lang=js&"
import style0 from "./AnalysisDetail.vue?vue&type=style&index=0&id=6ef8a892&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef8a892",
  null
  
)

export default component.exports